import { BZ2_SEARCH_IN_ALL } from 'mk/autogenerated/translations/TextSearch.deed9abd49e0f3f2e051745cdcd4ba91'
import { TextSearchForm } from 'mk2/apps/bazaar/components/TextSearchForm';
import React from 'react';

interface OwnProps {
    className?: string;
    value?: string;
    placeholder?: string;
    hideButtonUntilFocused?: boolean;
    outlined?: boolean;
    buttonLabel?: React.ReactNode;

    onChange?(value: string);
}

type Props = OwnProps;

const TextSearch: React.FunctionComponent<Props> = ({
    className,
    value = '',
    onChange,
    placeholder = BZ2_SEARCH_IN_ALL,
    hideButtonUntilFocused = false,
    outlined = false,
    buttonLabel,
}) => {
    return (
        <TextSearchForm
            className={className}
            value={value}
            placeholder={placeholder}
            hideButtonUntilFocused={hideButtonUntilFocused}
            outlined={outlined}
            buttonLabel={buttonLabel}
            onChange={onChange}
        />
    );
};

TextSearch.displayName = 'TextSearch';

export default React.memo<Props>(TextSearch);
